export const downloadFile = async (
    resource: Uint8Array,
    filename: string,
    applicationType: string,
) => {
    if (resource) {
        // doing a new Blob with Uint8Array to resolve "Type 'ArrayBufferLike' is not assignable to type 'BlobPart'"" type error
        const blob = new Blob([new Uint8Array(resource).buffer], {
            type: applicationType,
        });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
};
